import React, { useState, useEffect, useRef, useCallback } from "react";
import "./BrandSelect.css";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useSelector } from "react-redux";
import { selectAllWheelSizes } from "../../../../features/listingPage/listingPageSlice";
import { selectUser } from "../../../../features/auth/authSlice";

function WheelSizeSelect({ onSelect, closeWheelSizeSelect, previouslySelectedWheelSize }) {
  const wheelSizes = useSelector(selectAllWheelSizes);
  const [selectedWheelSizes, setSelectedWheelSizes] = useState(
    previouslySelectedWheelSize || []
  );
  const [searchQuery, setSearchQuery] = useState("");
  const userDetail = useSelector(selectUser)

  const handleCheckboxChange = (wheelSize) => {
    setSelectedWheelSizes((prevselectedWheelSizes) =>
      prevselectedWheelSizes.includes(wheelSize)
        ? prevselectedWheelSizes.filter((b) => b !== wheelSize)
        : [...prevselectedWheelSizes, wheelSize]
    );
  };

  const handleMobileCheckboxChange = (wheelSize) => {
    setSelectedWheelSizes((prevselectedWheelSizes) => {
      const updatedWheelSizes = prevselectedWheelSizes.includes(wheelSize)
        ? prevselectedWheelSizes.filter((b) => b !== wheelSize)
        : [...prevselectedWheelSizes, wheelSize];
      onSelect({ wheelSizes: updatedWheelSizes });
      return updatedWheelSizes;
    });
  };

  const handleApplyClick = () => {
  
    onSelect({ wheelSizes: selectedWheelSizes });
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Create a ref to the component
  const wheelSizeSelectRef = useRef(null);

 const handleClickOutside = useCallback(
     (event) => {
       if (
         wheelSizeSelectRef.current &&
         !wheelSizeSelectRef.current.contains(event.target)
       ) {
         closeWheelSizeSelect();
       }
     },
     [closeWheelSizeSelect]
   );
 
   useEffect(() => {
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, [handleClickOutside]);

  const filteredWheelSizes = wheelSizes?.filter((data) =>
    data.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div ref={wheelSizeSelectRef} className="brand-select-container">
      <div className="brand-select-btn-container">
        <span>{selectedWheelSizes.length} selected</span>
        <div className="brand-select-btn-contain">
          <button className="brand-select-btn-apply" onClick={handleApplyClick}>
            Apply
          </button>
          <button
            className="brand-select-btn-clear"
            onClick={() => setSelectedWheelSizes([])}
          >
            Clear
          </button>
        </div>
      </div>
      <div className="brand-select-search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <SearchSharpIcon className="brand-select-search-icon" />
      </div>
      <div className="brand-select-option-container">
        {filteredWheelSizes.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedWheelSizes.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedWheelSizes.includes(data)}
              onChange={() => handleCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span>{data}</span>
          </div>
        ))}
      </div>
      <div className="mobile-brand-select-option-container">
        {filteredWheelSizes.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedWheelSizes.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedWheelSizes.includes(data)}
              onChange={() => handleMobileCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span className="brand-name-span-d">{data}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WheelSizeSelect;
